import React from "react";

const Footer = () => {
  return (
    <>
      <footer style={{backgroundColor:'#1f2c35' }}>
        <div className="container"  >
          {/* <div className="row">
            <div className="col-lg-3 col-md-12">
              <p>
                <a href="index-2.html" title="Findoctor">
                  <img
                    src="img/logo.png"
                    data-retina="true"
                    alt=""
                    width="163"
                    height="36"
                    className="img-fluid"
                  />
                </a>
              </p>
             <input
                    type="text"
                    class="w-100 p-3 px-4 location"
                    placeholder="Enter e-mail"
                    style={{borderRadius:'30px',border:'2px solid white',backgroundColor:'#1f2c35',color:'white'}}
                  />
                <button className="btn btn-dark py-2 px-4 my-3 mx-2" style={{border:'1px solid white'}}>Subscribe to Newsletter  </button>
            </div>
            <div className="col-1"/>
            <div className="col-lg-2 col-md-4">
              <ul className="links">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About us</a>
                </li>
                <li>
                  <a href="/faq">FAQ</a>
                </li>
                <li>
                  <a href="/register">Register</a>
                </li>
                <li>
                  <a href="/Login">Login</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-4">
              <ul className="links">
                <li>
                  <a href="/practitioner">Practitioners</a>
                </li>
                <li>
                  <a href="/Training">Certification</a>
                </li>
                <li>
                  <a href="/Podcast">Podcasts</a>
                </li>
                <li>
                  <a href="/calendar">Calendar</a>
                </li>
                <li>
                  <a href="#Founders">Founders</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-4">
              <ul className="contacts">
                <li>
                  <a href="mailto:info@findoctor.com">
                    <i className="icon_mail_alt"></i> info@gafhc.com
                  </a>
                </li>
              </ul>
              <div className="follow_us">
                <h5>Follow us</h5>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/AcademyForHypnosis/">
                      <i className="social_facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/sharonwaxkirsh">
                      <i className="social_twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href=" https://www.linkedin.com/in/sharonwaxkirsh">
                      <i className="social_linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href=" https://www.instagram.com/hypsharon">
                      <i className="social_instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/user/sharonwaxkirsh">
                      <i className="social_youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          {/* <!--/row--> */}
          <hr />
          <div className="row">
            <div className="col-md-4">
              <ul id="additional_links">
                <li>
                  <a href="#0">Terms and conditions</a>
                </li>
                <li>
                  <a href="#0">Privacy</a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <div id="copy">Copyright @ 2023 Dentective, All Right Reserved</div>
            </div>
            <div className="col-md-4">
              <div id="copy">D.E.N.T.E.C.T.I.V.E</div>
            </div>
          </div>
        </div>
      </footer>
      {/* <!--/footer--> */}
    </>
  );
};

export default Footer;
